import {AdminPagingModel} from "./AdminPagingModel";
import {ScannerService} from "../../services/ScannerService";
import {NotificationService} from "../../services/NotificationService";
import {GridBookmarkService} from "../../services/GridBookmarkService";
import {Scanner} from "../../entities/Scanner";

export class ScannerAdminPagingModel extends AdminPagingModel<Scanner>{
    static $inject = ['$q','ScannerService','NotificationService','GridBookmarkService'];
    constructor($q:ng.IQService, pagingService:ScannerService,notificationService:NotificationService,
                gridBookmarkService:GridBookmarkService){
        super($q, pagingService,notificationService,gridBookmarkService);
    }
    getCustomActions():string[]{
        return [];
    }
    entityName():string{
        return "scanner";
    }
    displayName():string{
        return "Scanners";
    }
    addEditAllowed():boolean{
      return true;
    }
    deleteAllowed():boolean{
      return false;
    }
    getColumnDefs():ng.IPromise<void>{
        this.nameValuePairs =
            [
                ['deviceID', 'Device ID',200],
                ['companyName', 'Company Name', 215],
                ['inactive', 'Deactivated', 215],
                ['lastSeen', 'Last Seen', 175], 
                ['description', 'Description', 300],
            ];
        return this.$q.when();
    }
}
